<!-- The page scrolls instead of the container, so the header can span the full width -->
<div class="ticket-page" (scroll)="onScroll($event)">
    <div class="sticky-header">
        <div class="crud-header">
            <div class="ticket-header-logo">
                <img src="assets/logo/logo.svg" alt="TSNed">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col d-flex align-items-center gap-2 gap-sm-3">
                        <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}"
                             class="controls-left-button"
                             matTooltip="Terug naar projectenkaart"
                             matTooltipPosition="after">
                            <i class="fa fa-arrow-left-from-arc"></i>
                        </div>
                        <h1 class="mt-2">TVM-tickets</h1>
                        <i class="fa fa-2x fa-question-circle d-none d-sm-inline-block" (click)="info()"></i>
                        <button mat-icon-button type="button" class="ms-auto header-action d-none d-sm-inline-flex"
                                (click)="toggleAllNotifications()"
                                [matTooltip]="ticketNotifications ? 'Notificaties voor alle tickets uitzetten' : 'Notificaties voor alle tickets aanzetten'"
                                matTooltipTouchGestures="off">
                            <i class="fa-regular" [ngClass]="ticketNotifications ? 'fa-bell' : 'fa-bell-slash'"></i>
                        </button>
                        <!-- On mobile the actions move into a menu, so the header fits the screen -->
                        <button mat-icon-button type="button" class="ms-auto header-action d-sm-none" [matMenuTriggerFor]="headerMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #headerMenu="matMenu" xPosition="before">
                            <button mat-menu-item type="button" (click)="toggleAllNotifications()">
                                <i class="fa-regular header-menu-icon" [ngClass]="ticketNotifications ? 'fa-bell-slash' : 'fa-bell'"></i>
                                <span>{{ ticketNotifications ? 'Notificaties voor alle tickets uitzetten' : 'Notificaties voor alle tickets aanzetten' }}</span>
                            </button>
                            <button mat-menu-item type="button" (click)="info()">
                                <i class="fa-regular fa-circle-question header-menu-icon"></i>
                                <span>Uitleg</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-3">
            <div class="ticket-filterbar">
                <div class="filter-field filter-select">
                    <i class="fa-regular fa-user filter-icon"></i>
                    <ng-select class="p-0"
                               bindLabel="name"
                               bindValue="id"
                               placeholder="Selecteer gebruiker"
                               clearable="true"
                               appearance="outline"
                               [items]="users"
                               [formControl]="userIdControl"></ng-select>
                </div>

                @if (showDepartmentFilter) {
                    <div class="filter-field filter-select">
                        <i class="fa-regular fa-sitemap filter-icon"></i>
                        <ng-select class="p-0"
                                   placeholder="Alle afdelingen"
                                   clearable="true"
                                   appearance="outline"
                                   [formControl]="departmentControl">
                            <ng-option value="none">{{ null | TtmTicketDepartment }}</ng-option>
                            @for (department of departments | keyvalue: keepOrder; track department.key) {
                                <ng-option [value]="department.key">{{ department.value }}</ng-option>
                            }
                        </ng-select>
                    </div>
                }

                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-field filter-search">
                    <i matPrefix class="fa-regular fa-magnifying-glass filter-prefix"></i>
                    <mat-label>Zoeken</mat-label>
                    <input #searchInput matInput class="searchInput" placeholder="Zoeken" type="text"/>
                </mat-form-field>

                <!-- Sort field and direction button stay together, so the button never ends up on its own row -->
                <div class="filter-sort">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <i matPrefix class="fa-regular fa-bars-sort filter-prefix"></i>
                        <mat-label>Sorteer op</mat-label>
                        <mat-select [formControl]="sortByControl">
                            @for (option of sortOptions; track option.value) {
                                <mat-option [value]="option.value">{{option.label}}</mat-option>
                            }
                        </mat-select>
                        <!-- Mobile: the direction toggle sits inside the sort field instead of on its own row -->
                        <button matSuffix mat-icon-button type="button" class="sort-direction-suffix"
                                (click)="$event.stopPropagation(); toggleSortDirection()"
                                [attr.aria-label]="sortDirection === 'asc' ? 'Oplopend' : 'Aflopend'"
                                matTooltip="{{sortDirection === 'asc' ? 'Oplopend' : 'Aflopend'}}">
                            <i class="fa-regular" [ngClass]="sortDirection === 'asc' ? 'fa-arrow-up-short-wide' : 'fa-arrow-down-wide-short'"></i>
                        </button>
                    </mat-form-field>

                    <button mat-stroked-button type="button" (click)="toggleSortDirection()" class="sort-direction-button" matTooltip="{{sortDirection === 'asc' ? 'Oplopend' : 'Aflopend'}}">
                        <i class="fa-regular fa-arrow-up-arrow-down"></i>
                        <span>{{sortDirection === 'asc' ? 'Oplopend' : 'Aflopend'}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        @if (tickets$ | async; as tickets) {
            @if (tickets.length) {
                <div class="tickets-list mb-4">
                    @for (ticket of tickets; track ticket.id) {
                        <app-ttm-ticket-card
                            [ticket]="ticket"
                            (deleteTicket)="delete($event)">
                        </app-ttm-ticket-card>
                    }
                </div>
            } @else if (!loading) {
                <div class="empty-state mb-4">
                    <span class="empty-state-icon"><i class="fa-regular fa-inbox"></i></span>
                    <span>Geen tickets gevonden voor de huidige filters.</span>
                </div>
            }
        }

        @if (loading) {
            <div class="loading-indicator">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
            </div>
        }
    </div>
</div>
